// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2pWUW","search":"Settings_search__Ii_MV","filter":"Settings_filter__2imV7"};